module.exports = __webpack_public_path__ + "img/home-05-panoramic-layer-02.70d64cd0.png";